import React, { FC } from "react";
import Link from "next/link";
import dayjs from "dayjs";

interface AuthFooterProps {
  IsAbsolute?: boolean;
}

const AuthFooter: FC<AuthFooterProps> = ({ IsAbsolute }) => {
  const currentYear = dayjs().year();
  return (
    <>
      <div className="md:hidden flex gap-3 items-center justify-center mb-1 ">
        <Link href="/privacy" passHref className="text-xs  text-[#767676]">
          Privacy Cookies
        </Link>
        <span className="text-[#767676] text-[12px]">•</span>
        <Link
          href="/terms-and-conditions"
          passHref
          className="text-xs  text-[#767676]"
        >
          Terms & Conditions
        </Link>
      </div>
      <div className="text-[#767676] text-[12px] text-center mb-6 md:hidden block">
        Copyright &copy; {currentYear} Tripstick DMCC. All rights Reserved
      </div>

      <div
        className={`md:flex hidden  gap-x-[5px]  items-center md:flex-nowrap flex-wrap  ${IsAbsolute ? "absolute bottom-8 flex-wrap" : ""}  `}
      >
        <span className="text-xs  text-[#767676]">
          Copyright &copy; {currentYear} Tripstick DMCC
        </span>
        <span className="text-xs  text-[#767676]">•</span>
        <span className="text-xs  text-[#767676]">All rights Reserved</span>
        <span className="text-xs  text-[#767676]">•</span>
        <Link href="/privacy" passHref className="text-xs  text-[#767676]">
          Privacy Cookies
        </Link>
        <span className="text-xs  text-[#767676]">•</span>
        <Link
          href="/terms-and-conditions"
          passHref
          className="text-xs  text-[#767676]"
        >
          Terms & Conditions
        </Link>
      </div>
    </>
  );
};

export default AuthFooter;
